import React from "react";
//#region types
import { StyleEnums } from "models/enums";
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
import { ActionButton } from "models/propTypes/commonPropTypes";
import { TranslationKeys } from "translations";
import { RouteConstants } from "utils/constants";
import { QuotationFooterProps } from "models/propTypes/quotationPropTypes";
//#endregion
//#region components
import { PageFooter } from "components/common";
import { useNavigate, useLocation } from "react-router-dom";
import useQuotationPreview from "./usePreview";
import QuotationMoreActions from "./moreActions";
//#endregion
import { LocalizationHelperInstance, UrlHelper } from "utils/helpers";

const QuotationFooter: React.FC<QuotationFooterProps> = (props) => {
  const location = useLocation();
  const navigate = useNavigate();

  const onViewInvoice = async () => {
    navigate(UrlHelper.formatPath(`/Invoice/${props.quotation.invoiceId}`), {
      state: { background: location },
    });
  };

  const onEditQuotation = async () => {
    navigate(
      UrlHelper.formatPath(
        `/Quotation/${props.quotation.serialNumber}?${RouteConstants.QuotationQueryParams.IsEdit}=true`
      ),
      {
        state: { background: location },
      }
    );
  };

  const onCreateInvoiceFromQuotation = async () => {
    props.createOrUpdateQuotation && (await props.createOrUpdateQuotation());
    navigate(
      UrlHelper.formatPath(
        `/Invoice/Create?${RouteConstants.QueryParamStrings.QuotationTemplate}=${props.quotation.serialNumber}`
      ),
      {
        state: { background: location },
      }
    );
  };

  const { showPreviewDialog } = useQuotationPreview();

  const onShowQuotationPreview = async (defaultSendType?: WintSuperkollAPIModel.InvoiceSendMethod) => {
    showPreviewDialog(props.quotation, undefined, props.markAsDoneHandler, defaultSendType);
  };

  const getActions = () => {
    let actions: ActionButton[] = [];
    if (
      (props.quotation.quotationState === WintSuperkollAPIModel.QuotationApiState.NotSent ||
        props.quotation.quotationState === WintSuperkollAPIModel.QuotationApiState.Sent) &&
      props.quotation.endDate &&
      props.quotation.endDate > new Date()
    ) {
      actions = [
        {
          text: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Quotation.EditQuotation),
          onClick: onEditQuotation,
          type: StyleEnums.DisplayType.Success,
        },
      ];
    } else if (props.quotation.quotationState === WintSuperkollAPIModel.QuotationApiState.NotSent) {
      actions = [
        {
          text: TranslationKeys.Common.FinalReview,
          onClick: onShowQuotationPreview,
          type: StyleEnums.DisplayType.Success,
        },
      ];
    } else if (props.quotation.quotationState === WintSuperkollAPIModel.QuotationApiState.InvoiceCreated) {
      actions = [
        {
          text: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Quotation.ViewInvoice),
          onClick: onViewInvoice,
          type: StyleEnums.DisplayType.Success,
        },
      ];
    } else if (props.quotation.quotationState === WintSuperkollAPIModel.QuotationApiState.Won) {
      actions = [
        {
          text: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Quotation.CreateInvoice),
          onClick: onCreateInvoiceFromQuotation,
          type: StyleEnums.DisplayType.Success,
        },
      ];
    } else if (
      props.quotation.quotationState === WintSuperkollAPIModel.QuotationApiState.Sent ||
      props.quotation.quotationState === WintSuperkollAPIModel.QuotationApiState.Lost
    ) {
      actions = [
        {
          text: TranslationKeys.Quotation.MailCustomer,
          onClick: onShowQuotationPreview.bind(WintSuperkollAPIModel.InvoiceSendMethod.Email),
          type: StyleEnums.DisplayType.Success,
        },
      ];
    }

    return actions;
  };

  return <PageFooter actions={getActions()} moreActions={<QuotationMoreActions quotation={props.quotation} />} />;
};

export default QuotationFooter;
